import { render } from "./App.vue?vue&type=template&id=4c73e5d4&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4c73e5d4&scoped=true&lang=css"

import exportComponent from "/builds/proximis/page_abonnement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c73e5d4"]])

export default __exports__